<template>
  <ion-page>
    <master-layout pageTitle="ثبت خروجی انبار">
      <AjaxForm :route="'submitOutInvoice/'+id">
        <h4>اقلام فاکتور خروجی</h4>
        <div class="card" v-for="(item,index) in items" :key="index">
          <div class="card-body">
            <div class="item">
              <div>محصول</div>
              <div>
                <ali-ajax-select :index="index" :route="'App/Select/GetWarehouseProduct/'+id+'?app=true'"
                                 title="محصولات"
                                 itemTitle="name" name="w_p_ids[]" desc="جستجو محصول..." itemId="id"></ali-ajax-select>

              </div>
            </div>
            <div class="item">
              <div>تعداد</div>
              <div>
                <input type="text" name="quantities[]" :data-index="index"
                       class="form-control only_number quantity form-control-sm"
                       placeholder="تعداد...">
              </div>
            </div>
            <div class="item">
              <div class="w-50 ion-padding">
                <button v-if="index" @click="deleteItem(index)" type="button" class="btn btn-danger btn-block"><i
                    class="fas fa-times"></i></button>
              </div>
              <div class="w-50 ion-padding">
                <button @click="addItem" type="button" class="btn btn-success btn-block">
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="ion-padding">
          <button class="btn btn-warning btn-block ion-padding" type="submit">ثبت خروجی انبار</button>
        </div>
      </AjaxForm>
    </master-layout>
  </ion-page>
</template>

<script>
import {
  IonPage
} from "@ionic/vue";
import AliAjaxSelect from "@/components/aliAjaxSelect/index";
import {mapActions} from "vuex";
import {showSystemNoti} from "@/shared/helper";
import AjaxForm from "@/components/AjaxForm";

export default {
  data()
  {
    return {
      id: null,
      total_buy_price: 0,
      draft_number: '',
      content: '',
      items: [
        {
          product_id: null,
          quantity: 0,
        }
      ]
    };
  },
  async created()
  {
    this.id = this.$route.params.warehouseId;
  },
  methods: {
    ...mapActions("app", {
      getProductVariableAttr: 'getProductVariableAttr'
    }),
    ...mapActions("warehouse", {
      addProductToWarehouse: 'addProductToWarehouse'
    }),
    addItem: function ()
    {
      this.items.push(
          {
            product_id: null,
            product_type: '',
            quantity: 0,
            buy_price: 0,
            attrItems: [],
            attr: null,
          });
    },
    deleteItem: function (index)
    {
      this.items.splice(index, 1);
      this.setTotalBuyPrice();
    },
    submit: async function ()
    {
      /**
       * ToDo:
       *  file ids
       */
      const data = {
        "warehouse_id": this.id,
        "items": this.items,
        "file_ids": [],
        "draft_number": this.draft_number,
        "content": this.content
      };
      const result = await this.addProductToWarehouse(data);
      if (result)
      {
        if (result.ok)
        {
          showSystemNoti('success', result.message);

          this.total_buy_price = 0;
          this.draft_number = '';
          this.content = ''
          this.items = [
            {
              product_id: null,
              product_type: '',
              quantity: 0,
              buy_price: 0,
              attrItems: [],
              attr: null,
            }
          ]
          this.setTotalBuyPrice()
        }
        else
          showSystemNoti('danger', result.error);
      }

    }
  },
  components: {
    AjaxForm,
    AliAjaxSelect,
    IonPage
  }
};
</script>

<style scoped>

</style>